// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 829) return "js/829.js";
	// return url for filenames based on template
	return undefined;
};